module.exports = __webpack_public_path__ + "img/lajitong.f5f7a6f6.png";